import { STUDIO_CONFIG } from '@constants/studio-type-icons';
import {
  STUDIO_TYPE_LABELS,
  StudioType,
} from '@conversed/shared/src/central/types/studio.type';
import { useStudioInstallAction } from '@hooks/home/useStudioInstallAction';
import { useModal } from '@hooks/modal/useModal';
import { useCompanySelector } from '@hooks/useCompanySelector';
import { useStudioSwitch } from '@hooks/useStudioSwitch';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { StudioTab } from './StudioTab';

export const StudioSwitcherTabs: React.FC = () => {
  const { selectedCompany, selectedCompanyStudios } = useCompanySelector();
  const { switchStudio } = useStudioSwitch();
  const { getStudioAction } = useStudioInstallAction();
  const { showModal } = useModal();
  const { t } = useTranslation();

  return (
    <div className='flex items-center h-[32px] md:h-[38px] gap-1 p-1 rounded-xl border border-gray-200 bg-slate-50 min-w-0 overflow-hidden'>
      {Object.values(StudioType).map((studioType) => {
        const config = STUDIO_CONFIG[studioType];
        const installedStudio = selectedCompanyStudios.find(
          (studio) => studio.studioType === studioType,
        );
        const isInstalled = installedStudio !== undefined;
        const isActive =
          isInstalled &&
          installedStudio.identifier === selectedCompany?.identifier;

        const handleClick = isInstalled
          ? () => switchStudio(installedStudio.identifier)
          : () => {
              const studioLabel = STUDIO_TYPE_LABELS[studioType];
              showModal('general-prompt-modal-v2', studioLabel, {
                type: 'confirm',
                description: t('home.v2.other-studios.not-installed-modal', {
                  studio: studioLabel,
                }),
                customButtons: [
                  {
                    text: t('home.v2.other-studios.install', {
                      studio: studioLabel,
                    }),
                    styling: 'primary',
                    onClick: getStudioAction(studioType),
                  },
                ],
              });
            };

        return (
          <StudioTab
            key={studioType}
            iconSrc={config.iconSrc}
            label={STUDIO_TYPE_LABELS[studioType]}
            isActive={isActive}
            isInstalled={isInstalled}
            textClass={config.valueColorClass}
            borderClass={config.borderColorClass}
            onClick={handleClick}
          />
        );
      })}
    </div>
  );
};

export default StudioSwitcherTabs;
